import { Spinner, Text, Card, Icon } from "@nike/eds";

export const TableSpinner = () => (
    <div className="noDataText">
        <Spinner className="eds-spacing--mt-8 eds-spacing--mb-8" size='large' />
    </div>
);

export const TableMessage = ({ msg }: { msg: string }) => (
    <div className='noDataText'>
        <Text font="title-4" as="h4" className="eds-spacing--mt-56 eds-spacing--mb-56" style={{ justifyContent: "center", textAlign: "center" }}>{msg}</Text>
    </div>
);

export const TableError = ({ title = "Oops, something went wrong", message }: { title?: string; message: string }) => (
    <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
        <Card style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "32px 24px", border: "1px solid var(--eds-color-red-40, #f44336)", backgroundColor: "var(--eds-color-red-10, #ffeaea)", maxWidth: "480px", width: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }}>
            <Icon name="InfoCircle" color="var(--eds-color-red-60, #d32f2f)" size="l" />
            <Text font="title-4" as="h4" style={{ color: "var(--eds-color-red-60, #d32f2f)" }}>{title}</Text>
            <Text font="body-2" as="p" style={{ color: "var(--eds-color-red-60, #d32f2f)", textAlign: "center", margin: 0 }}>{message}</Text>
        </Card>
    </div>
);
